import { useEffect, useState } from 'react';
import { mapData } from './mapData';
import court from '../../Images/about.svg'
import { ArrowLeft, EmailOutlined, LocationOnOutlined, PhoneOutlined } from '@mui/icons-material';

const MapComponent = () => {
  const [selectedEtrap, setSelectedEtrap] = useState(null);
  const [selectedVelayat, setSelectedVelayat] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null)
  const [lng, setLng] = useState(null);
  const [lat, setLat] = useState(null);

  useEffect(() => {
    if (selectedEtrap) {
      setLat(selectedEtrap.coords[0]);
      setLng(selectedEtrap.coords[1]);
    } else if (selectedCity) {
      setLat(selectedCity.coords[0]);
      setLng(selectedCity.coords[1]);
    } else if (selectedVelayat) {
      setLat(selectedVelayat.coords[0]);
      setLng(selectedVelayat.coords[1]);
    }
  }, [selectedEtrap, selectedCity, selectedVelayat]);

  const handleEtrapClick = (etrap) => {
    setSelectedVelayat(null)
    setSelectedCity(null)
    setSelectedEtrap(etrap);
    setLat(etrap.coords[0]);
    setLng(etrap.coords[1]);
    const velayat = mapData.velayats.find(v => v.etraps.some(e => e.id === etrap.id));
    setSelectedVelayat(velayat);
  };

  const handleCityClick = (city) => {
    if (city && city.id) {
      const velayat = mapData.velayats.find(v => v.cities && v.cities.some(e => e.id === city.id));
      if (velayat) {
        setSelectedVelayat(velayat);
        setSelectedEtrap(null);
        setSelectedCity(city);
        setLat(city.coords[0]);
        setLng(city.coords[1]);
      } else {
        console.error('Velayat not found for the city');
      }
    } else {
      console.error('Invalid city object');
    }
  };

  const handleSelectVelayatChange = (velayatId) => {
    const velayat = mapData.velayats.find(v => v.id === velayatId);
    if (velayat) {
      setSelectedVelayat(velayat);
      setSelectedEtrap(null);
      setSelectedCity(null);
      setLat(null);
      setLng(null);
    } else {
      console.error('Velayat not found');
    }
  };

  const handleSelectEtrapChange = (etrapId) => {
    const etrap = mapData.velayats.flatMap(v => v.etraps).find(e => e.id === etrapId);
    if (etrap) {
      handleEtrapClick(etrap);
    }
  };

  const handleSelectCityChange = (cityId) => {
    const city = mapData.velayats.flatMap(v => v.cities).find(c => c.id === cityId);
    if (city) {
      handleCityClick(city);
    }
  };

  const goBackToVelayats = () => {
    setSelectedVelayat(null);
    setLat(null);
    setLng(null);
  };

  return (
    <div>
      <section className="lg:flex justify-between gap-6 items-center lg:h-[500px]">
        <div className="lg:w-[55%] h-full bg-white rounded-md
                        p-24 xxxxl:p-32 dark:bg-dark-box dark:border-dark-border">
          <div className='w-full h-full flex items-center'>
            <svg
              viewBox="0 0 29700 21000"
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: '100%', height: 'auto' }}
            >
              {mapData?.velayats?.map(velayat => (
                <g key={velayat.id}>
                  <path
                    id={velayat.id}
                    d={velayat.path}
                    fill={
                      velayat.id === 'ashgabat'
                        ? '#003aa6ca'
                        : selectedVelayat?.id === velayat.id
                          ? '#003aa6ca'
                          : 'rgba(0, 0, 0, 0)'
                    }
                    stroke='rgba(0, 98, 130, 0.93)'
                    strokeWidth="70"
                    onClick={() => handleSelectVelayatChange(velayat.id)}
                  />

                  {velayat?.etraps?.map(etrap => (
                    <g
                      key={etrap.id}
                      onClick={() => handleEtrapClick(etrap)}
                      style={{ cursor: 'pointer' }}
                    >
                      <path
                        id={etrap.id}
                        d={etrap.path}
                        fill={selectedEtrap?.id === etrap.id ? '#0039a6'
                          : 'rgba(171, 182, 201, 0.7)'}
                        stroke="#fff"
                        strokeWidth="20"
                      />
                    </g>
                  ))}

                  {velayat?.cities?.map(city => (
                    <g
                      key={city.id}
                      onClick={() => handleCityClick(city)}
                      style={{ cursor: 'pointer' }}
                    >
                      <circle
                        id={city.id}
                        cx={city.cx}
                        cy={city.cy}
                        r="210"
                        fill={selectedCity?.id === city.id ? '#0039a6' : '#c3c3c300'}
                      />
                    </g>
                  ))}
                </g>
              ))}
            </svg>
          </div>
        </div>
        <div className="lg:w-[45%] h-full bg-white
                        rounded-md mt-6 xl:mt-0 relative dark:bg-dark-box
                        dark:border-dark-border dark:text-dark-text pb-6">
          {!selectedVelayat ? (
            <div>
              <h3 className="p-4 mb-2 bg-primary text-white dark:bg-dark-box text-center
                             dark:border-b dark:border-b-dark-border dark:text-dark-text
                             rounded-t-lg">
                Şäherler we welaýatlar
              </h3>
              <ul>
                {mapData?.velayats?.map(velayat => (
                  <li
                    key={velayat.id}
                    className="cursor-pointer hover:bg-gray-200 px-5 
                               border-b border-b-secondary py-4 
                               dark:border-b-dark-border"
                    onClick={() => handleSelectVelayatChange(velayat.id)}
                  >
                    {velayat.name}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className='h-full'>
              <div className='flex justify-between items-center p-4 mb-2 
                              bg-primary text-white dark:bg-dark-box 
                              dark:border-b dark:border-b-dark-border 
                              dark:text-dark-text rounded-t-lg'>
                <h3 className="font-semibold text-lg">
                  {selectedVelayat.name}
                </h3>
                {selectedVelayat && (
                  <button
                    onClick={goBackToVelayats}
                  >
                    <ArrowLeft /> Yza çykmak
                  </button>
                )}
              </div>
              <ul className='h-[80%] overflow-y-scroll'>
                {selectedVelayat?.cities?.map(city => (
                  <div key={city.id}>
                    {city.name &&
                      <li
                        key={city.id}
                        className="cursor-pointer px-5 py-4 border-b border-b-secondary"
                        onClick={() => handleSelectCityChange(city.id)}
                      >
                        {city.name}
                      </li>
                    }
                  </div>
                ))}
                {selectedVelayat?.etraps?.map(etrap => (
                  <li
                    key={etrap.id}
                    className="cursor-pointer px-5 py-4 border-b border-b-secondary"
                    onClick={() => handleSelectEtrapChange(etrap.id)}
                  >
                    {etrap.name}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </section>
      {lng && lat &&
        <section className='p-8 mt-8 bg-white rounded-md dark:bg-dark-box'>
          <h1 className='text-center mb-8 text-primary font-bold text-xl'>
            {selectedCity?.name || selectedEtrap?.name || selectedVelayat?.name || ''}
          </h1>
          <div className='lg:flex justify-beween gap-12 w-full'>
            {lng && lat && (
              <div className="lg:w-[55%]">
                <iframe
                  title='Map'
                  name="frame"
                  src={`https://maps.google.com/maps?q=${lat},${lng}&hl=es;z=15&output=embed`}
                  frameBorder="0"
                  style={{ border: "0", width: "100%", height: "100%", position: "relative" }}
                  allowFullScreen
                ></iframe>
              </div>
            )}
            <div className='lg:w-[45%]'>
              <ul className='space-y-2 mb-4 mt-4 lg:mt-0 dark:text-dark-text'>
                <li>
                  <PhoneOutlined className='text-primary' />
                  : {selectedCity?.phone || selectedEtrap?.phone || selectedVelayat?.phone || ''}
                </li>
                <li>
                  <EmailOutlined className='text-primary' />
                  : {selectedCity?.email || selectedEtrap?.email || selectedVelayat?.email || ''}
                </li>
                <li>
                  <LocationOnOutlined className='text-primary' />
                  :  {selectedCity?.address || selectedEtrap?.address || selectedVelayat?.address || ''}
                </li>
              </ul>
              <img
                src={court}
                alt="court"
                loading="lazy"
              />
            </div>
          </div>
        </section>
      }
    </div>
  );
};

export default MapComponent;
